<template>
  <div class="container py-4 col-12 col-lg-10 mx-auto" id="container">

    <!-- BREADCRUMB
    <nav class="mt-3 mb-3 mb-md-5" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/"><b>Início</b></router-link>
        </li>
        <li class="breadcrumb-item active">Admin</li>
      </ol>
    </nav> -->

    <!-- TÍTULO PRINCIPAL -->
    <div class="row mb-md-5 page-header">
      <div class="col-12">
        <p class="page-header-eyebrow">ADMINISTRAÇÃO</p>
        <h1 class="page-title mb-1">Admin</h1>
        <p class="page-subtitle mb-0">Somente para administradores.</p>
      </div>
    </div>

    <nav class="dashboard-tabs" aria-label="Seções administrativas">
      <button
        v-for="aba in abas"
        :key="aba.id"
        type="button"
        :class="['dashboard-tab', { 'dashboard-tab--active': activeAba === aba.id }]"
        @click="selecionarAba(aba.id)"
      >
        {{ aba.label }}
      </button>
    </nav>

    <section v-if="activeAba === 'visao-geral'">
    <!-- ===== DADOS DOS USUÁRIOS ===== -->
    <div class="row mt-5 mb-3">
      <div class="col-12">
        <h5 class="dashboard-section-title mb-0">Usuários</h5>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-primary-soft"><i class="bi bi-people"></i></div>
          <div><p class="label">Usuários</p><h4 class="value">{{ stats.usuarios }}</h4></div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-success-soft"><i class="bi bi-folder"></i></div>
          <div><p class="label">Projetos criados</p><h4 class="value">{{ stats.projetos }}</h4></div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-warning-soft"><i class="bi bi-box"></i></div>
          <div><p class="label">Componentes criados</p><h4 class="value">{{ stats.componentes }}</h4></div>
        </div>
      </div>
      <div class="w-100 d-none d-lg-block"></div>
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-info-soft"><i class="bi bi-bar-chart"></i></div>
          <div><p class="label">Média de projetos por usuário</p><h4 class="value">{{ formatarMedia(stats.mediaProjetosPorUsuario) }}</h4></div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-primary-soft"><i class="bi bi-bar-chart-fill"></i></div>
          <div><p class="label">Média de componentes por usuário</p><h4 class="value">{{ formatarMedia(stats.mediaComponentesPorUsuario) }}</h4></div>
        </div>
      </div>
    </div>

    <!-- ===== ASSINATURAS (STRIPE) ===== -->
    <div class="row mt-5 mb-3">
      <div class="col-12">
        <h5 class="dashboard-section-title mb-0">Assinaturas</h5>
      </div>
    </div>

    <div class="row g-3">

      <!-- TOTAL -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-info-soft">
            <i class="bi bi-credit-card"></i>
          </div>
          <div>
            <p class="label">Total</p>
            <h4 class="value">{{ stats.assinantes }}</h4>
          </div>
        </div>
      </div>

      <!-- ACTIVE -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-success-soft">
            <i class="bi bi-check-circle"></i>
          </div>
          <div>
            <p class="label">Ativas</p>
            <h4 class="value">{{ stats.assinantesActive }}</h4>
          </div>
        </div>
      </div>

      <!-- TRIALING -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-warning-soft">
            <i class="bi bi-hourglass-split"></i>
          </div>
          <div>
            <p class="label">Em teste</p>
            <h4 class="value">{{ stats.assinantesTrialing }}</h4>
          </div>
        </div>
      </div>

      <!-- PAST DUE -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-warning-soft">
            <i class="bi bi-exclamation-circle"></i>
          </div>
          <div>
            <p class="label">Pagamento atrasado</p>
            <h4 class="value">{{ stats.assinantesPastDue }}</h4>
          </div>
        </div>
      </div>

      <!-- UNPAID -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-danger-soft">
            <i class="bi bi-x-circle"></i>
          </div>
          <div>
            <p class="label">Não pagas</p>
            <h4 class="value">{{ stats.assinantesUnpaid }}</h4>
          </div>
        </div>
      </div>

      <!-- CANCELED -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-secondary-soft">
            <i class="bi bi-slash-circle"></i>
          </div>
          <div>
            <p class="label">Canceladas</p>
            <h4 class="value">{{ stats.assinantesCanceled }}</h4>
          </div>
        </div>
      </div>

      <!-- INCOMPLETE -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-secondary-soft">
            <i class="bi bi-dash-circle"></i>
          </div>
          <div>
            <p class="label">Incompletas</p>
            <h4 class="value">{{ stats.assinantesIncomplete }}</h4>
          </div>
        </div>
      </div>

      <!-- INCOMPLETE EXPIRED -->
      <div class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div class="icon-box bg-secondary-soft">
            <i class="bi bi-clock-history"></i>
          </div>
          <div>
            <p class="label">Incompletas expiradas</p>
            <h4 class="value">{{ stats.assinantesIncompleteExpired }}</h4>
          </div>
        </div>
      </div>

      <!-- TIPOS DE ASSINATURA -->
      <div class="col-12 mt-4 pt-2">
        <h5 class="dashboard-section-title mb-0">Tipos de assinatura</h5>
      </div>

      <div v-for="tipo in tiposAssinatura" :key="tipo.chave" class="col-12 col-md-6 col-lg-3">
        <div class="dashboard-card">
          <div :class="['icon-box', tipo.classeIcone]"><i :class="tipo.icone"></i></div>
          <div><p class="label">{{ tipo.label }}</p><h4 class="value">{{ stats[tipo.chave] }}</h4></div>
        </div>
      </div>
    </div>

    <div class="new-subscribers-panel mt-4">
      <div class="new-subscribers-panel__header">
        <div>
          <h5 class="dashboard-section-title mb-1">Novos assinantes</h5>
          <p class="dashboard-panel-subtitle mb-0">Novas assinaturas em {{ periodoNovosAssinantes }}</p>
        </div>
        <strong class="new-subscribers-panel__count">{{ stats.novosAssinantes || 0 }}</strong>
        <select v-model="filtroAnoAssinantes" class="new-subscribers-panel__year" aria-label="Filtrar assinaturas por ano" @change="carregarNovosAssinantes">
          <option v-for="ano in anosFiltroAssinantes" :key="ano" :value="ano">{{ ano }}</option>
        </select>
      </div>

      <div class="new-subscribers-chart mt-3" aria-label="Assinaturas por mês nos últimos 12 meses">
        <div v-for="item in serieNovosAssinantes" :key="item.data" class="new-subscriber-chart__item">
          <span class="new-subscriber-chart__quantity">{{ item.quantidade }}</span>
          <div class="new-subscriber-chart__track">
            <div
              class="new-subscriber-chart__bar"
              :style="{ height: `${alturaBarra(item.quantidade)}%` }"
              :title="`${formatarDataGrafico(item.data)}: ${item.quantidade} assinatura(s)`"
            ></div>
          </div>
          <small>{{ formatarDataGrafico(item.data) }}</small>
        </div>
      </div>
    </div>

    </section>

    <section v-if="activeAba === 'contas'">

    <div class="account-filters">
      <div class="account-filter account-filter--search">
        <h5 class="dashboard-section-title mb-0">Todas as contas</h5>
        <input
          v-model.trim="filtroContas.texto"
          type="search"
          placeholder="Filtrar por nome, e-mail ou empresa"
          aria-label="Filtrar contas por nome, e-mail ou empresa"
        />
      </div>
      <div class="account-filter account-filter--status">
        <label class="account-filter-label" for="dashboard-status-filter">Status</label>
        <select id="dashboard-status-filter" v-model="filtroContas.status" aria-label="Filtrar contas por status">
          <option value="">Todos os status</option>
          <option v-for="status in statusContas" :key="status" :value="status">
            {{ status }}
          </option>
        </select>
      </div>
    </div>

    <div class="student-users-table-wrapper">
      <div v-if="!contasFiltradas.length" class="student-request-empty">
        Nenhuma conta encontrada.
      </div>

      <table v-else class="student-users-table">
        <thead>
          <tr>
            <th>Usuário</th>
            <th>Empresa</th>
            <th>Tipo de assinatura</th>
            <th>Status</th>
            <th>Data de início</th>
            <th>Tempo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="conta in contasPaginadas" :key="conta.email">
            <td>
              <strong>{{ conta.nome }}</strong>
              <small>{{ conta.email }}</small>
            </td>
            <td>{{ conta.empresa || '-' }}</td>
            <td>
              <strong>{{ conta.tipo_assinatura }}</strong>
              <small>{{ conta.tipo_conta }}</small>
            </td>
            <td>
              <span :class="['request-status', `request-status--${conta.status}`]">
                {{ conta.status }}
              </span>
            </td>
            <td>{{ conta.data_inicio_formatada || formatarDataUnix(conta.data_inicio_unix) }}</td>
            <td>{{ formatarTempo(conta) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav v-if="totalPaginasContas > 1" class="d-flex justify-content-center mt-3" aria-label="Paginação das contas">
      <ul class="pagination pagination-projetos mb-0">
        <li class="page-item" :class="{ disabled: paginaContas === 1 }"><button type="button" class="page-link" :disabled="paginaContas === 1" @click="irParaPaginaContas(paginaContas - 1)">Anterior</button></li>
        <li v-for="pagina in totalPaginasContas" :key="pagina" class="page-item" :class="{ active: paginaContas === pagina }"><button type="button" class="page-link" @click="irParaPaginaContas(pagina)">{{ pagina }}</button></li>
        <li class="page-item" :class="{ disabled: paginaContas === totalPaginasContas }"><button type="button" class="page-link" :disabled="paginaContas === totalPaginasContas" @click="irParaPaginaContas(paginaContas + 1)">Próxima</button></li>
      </ul>
    </nav>

    </section>

    <section v-if="activeAba === 'estudantes'">

    <div class="row mt-5 mb-3 align-items-center">
      <div class="col-12">
        <h5 class="dashboard-section-title mb-0">Solicitações de licença estudantil</h5>
      </div>
    </div>

    <div class="student-requests">
      <div v-if="!solicitacoesPendentes.length" class="student-request-empty">
        Nenhuma solicitação pendente.
      </div>

      <article v-for="solicitacao in solicitacoesPendentesPaginadas" :key="solicitacao.id" class="student-request">
        <div class="student-request__content">
          <div class="student-request__header">
            <div>
              <h6>{{ solicitacao.nome }}</h6>
              <span>{{ solicitacao.email }}</span>
            </div>
            <span :class="['request-status', `request-status--${solicitacao.status}`]">
              {{ solicitacao.status }}
            </span>
          </div>

          <dl class="student-request__details">
            <div><dt>CPF</dt><dd>{{ solicitacao.cpf || 'Não informado' }}</dd></div>
            <div><dt>Universidade</dt><dd>{{ solicitacao.universidade }}</dd></div>
            <div><dt>Curso</dt><dd>{{ solicitacao.curso }}</dd></div>
            <div><dt>Recebida em</dt><dd>{{ formatarData(solicitacao.criadoEm) }}</dd></div>
            <div><dt>Documento</dt><dd>{{ solicitacao.carteirinha?.nome || 'Não informado' }}</dd></div>
          </dl>
        </div>

        <div class="student-request__actions">
          <button type="button" class="btn btn-secundario btn-sm" :disabled="loading.visible" @click="visualizarCarteirinha(solicitacao)">
            Baixar carteirinha
          </button>
          <button v-if="solicitacao.status === 'pendente'" type="button" class="botao-azul btn btn-primary" :disabled="loading.visible" @click="aprovarSolicitacao(solicitacao)">
            Aprovar e enviar acesso
          </button>
          <button v-if="solicitacao.status === 'pendente'" type="button" class="botao-vermelho btn" :disabled="loading.visible" @click="rejeitarSolicitacao(solicitacao)">
            Rejeitar
          </button>
        </div>
      </article>
    </div>

    <nav v-if="totalPaginasSolicitacoes > 1" class="d-flex justify-content-center mt-3" aria-label="Paginação das solicitações">
      <ul class="pagination pagination-projetos mb-0">
        <li class="page-item" :class="{ disabled: paginaSolicitacoes === 1 }"><button type="button" class="page-link" :disabled="paginaSolicitacoes === 1" @click="irParaPaginaSolicitacoes(paginaSolicitacoes - 1)">Anterior</button></li>
        <li v-for="pagina in totalPaginasSolicitacoes" :key="pagina" class="page-item" :class="{ active: paginaSolicitacoes === pagina }"><button type="button" class="page-link" @click="irParaPaginaSolicitacoes(pagina)">{{ pagina }}</button></li>
        <li class="page-item" :class="{ disabled: paginaSolicitacoes === totalPaginasSolicitacoes }"><button type="button" class="page-link" :disabled="paginaSolicitacoes === totalPaginasSolicitacoes" @click="irParaPaginaSolicitacoes(paginaSolicitacoes + 1)">Próxima</button></li>
      </ul>
    </nav>

    <div class="row mt-5 mb-3">
      <div class="col-12">
        <h5 class="dashboard-section-title mb-0">Usuários estudantes</h5>
      </div>
    </div>

    <div class="student-users-table-wrapper">
      <div v-if="!estudantes.length" class="student-request-empty">
        Nenhum usuário estudante aprovado.
      </div>

      <table v-else class="student-users-table">
        <thead>
          <tr>
            <th>Usuário</th>
            <th>Universidade</th>
            <th>Início da licença</th>
            <th>Fim da licença</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="estudante in estudantesPaginados" :key="estudante.email">
            <td>
              <strong>{{ estudante.nome }}</strong>
              <small>{{ estudante.email }}</small>
            </td>
            <td>{{ estudante.universidade || '-' }}</td>
            <td>{{ estudante.data_inicio_formatada || formatarDataUnix(estudante.data_inicio_unix) }}</td>
            <td>{{ estudante.data_fim_formatada || formatarDataUnix(estudante.data_fim_unix) }}</td>
            <td>
              <span :class="['request-status', `request-status--${estudante.status}`]">
                {{ estudante.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav v-if="totalPaginasEstudantes > 1" class="d-flex justify-content-center mt-3" aria-label="Paginação dos usuários estudantes">
      <ul class="pagination pagination-projetos mb-0">
        <li class="page-item" :class="{ disabled: paginaEstudantes === 1 }"><button type="button" class="page-link" :disabled="paginaEstudantes === 1" @click="irParaPaginaEstudantes(paginaEstudantes - 1)">Anterior</button></li>
        <li v-for="pagina in totalPaginasEstudantes" :key="pagina" class="page-item" :class="{ active: paginaEstudantes === pagina }"><button type="button" class="page-link" @click="irParaPaginaEstudantes(pagina)">{{ pagina }}</button></li>
        <li class="page-item" :class="{ disabled: paginaEstudantes === totalPaginasEstudantes }"><button type="button" class="page-link" :disabled="paginaEstudantes === totalPaginasEstudantes" @click="irParaPaginaEstudantes(paginaEstudantes + 1)">Próxima</button></li>
      </ul>
    </nav>

    </section>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      v-model:visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />
    
  </div>
</template>

<script>

import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { getSessionId, getUsuario } from '@/utils/authStorage';

export default {
  name: "Admin",
  data() {
    return {
      usuarioLogado: null,
      activeAba: 'visao-geral',
      abas: [
        { id: 'visao-geral', label: 'Visão geral' },
        { id: 'contas', label: 'Contas' },
        { id: 'estudantes', label: 'Licenças estudantis' }
      ],
      stats: {
        usuarios: 0,
        projetos: 0,
        componentes: 0,
        mediaProjetosPorUsuario: 0,
        mediaComponentesPorUsuario: 0,

        assinantes: 0,
        assinantesActive: 0,
        assinantesTrialing: 0,
        assinantesPastDue: 0,
        assinantesUnpaid: 0,
        assinantesCanceled: 0,
        assinantesIncomplete: 0,
        assinantesIncompleteExpired: 0,
        assinantesPagantes: 0,
        assinantesEstudantes: 0,
        assinantesFundadores: 0,
        assinantesVitalicias: 0,
        novosAssinantes: 0,
          serieNovosAssinantes: []
      },
        filtroAnoAssinantes: 2026,
      solicitacoes: [],
      estudantes: [],
      contas: [],
      itensPorPagina: 5,
      paginaContas: 1,
      paginaSolicitacoes: 1,
      paginaEstudantes: 1,
      filtroContas: {
        texto: '',
        status: ''
      },

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      }
    };
  },
  components: {
    AlertModal,
    LoadingModal
  },
  computed: {
    serieNovosAssinantes() {
      return this.stats.serieNovosAssinantes || [];
    },
    tiposAssinatura() {
      return [
        { chave: 'assinantesPagantes', label: 'Pagantes', icone: 'bi bi-person-check', classeIcone: 'bg-primary-soft' },
        { chave: 'assinantesEstudantes', label: 'Estudantes', icone: 'bi bi-mortarboard', classeIcone: 'bg-info-soft' },
        { chave: 'assinantesFundadores', label: 'Fundadores', icone: 'bi bi-star', classeIcone: 'bg-warning-soft' },
        { chave: 'assinantesVitalicias', label: 'Vitalícias', icone: 'bi bi-infinity', classeIcone: 'bg-success-soft' }
      ];
    },
    anosFiltroAssinantes() {
      const anoAtual = new Date().getUTCFullYear();
      return Array.from({ length: Math.max(2, anoAtual - 2026 + 2) }, (_, indice) => 2026 + indice);
    },
    periodoNovosAssinantes() {
      return this.filtroAnoAssinantes === 2026
        ? 'outubro a dezembro de 2026'
        : `janeiro a dezembro de ${this.filtroAnoAssinantes}`;
    },
    solicitacoesPendentes() {
      return this.solicitacoes.filter((solicitacao) => solicitacao.status === 'pendente');
    },
    totalPaginasContas() {
      return Math.max(1, Math.ceil(this.contasFiltradas.length / this.itensPorPagina));
    },
    contasPaginadas() {
      const inicio = (this.paginaContas - 1) * this.itensPorPagina;
      return this.contasFiltradas.slice(inicio, inicio + this.itensPorPagina);
    },
    totalPaginasSolicitacoes() {
      return Math.max(1, Math.ceil(this.solicitacoesPendentes.length / this.itensPorPagina));
    },
    solicitacoesPendentesPaginadas() {
      const inicio = (this.paginaSolicitacoes - 1) * this.itensPorPagina;
      return this.solicitacoesPendentes.slice(inicio, inicio + this.itensPorPagina);
    },
    totalPaginasEstudantes() {
      return Math.max(1, Math.ceil(this.estudantes.length / this.itensPorPagina));
    },
    estudantesPaginados() {
      const inicio = (this.paginaEstudantes - 1) * this.itensPorPagina;
      return this.estudantes.slice(inicio, inicio + this.itensPorPagina);
    },
    statusContas() {
      return [...new Set(this.contas.map((conta) => conta.status))].sort();
    },
    contasFiltradas() {
      const texto = this.filtroContas.texto.toLowerCase();
      return this.contas.filter((conta) => {
        const correspondeTexto = !texto || [conta.nome, conta.email, conta.empresa]
          .some((valor) => String(valor || '').toLowerCase().includes(texto));
        const correspondeStatus = !this.filtroContas.status || conta.status === this.filtroContas.status;
        return correspondeTexto && correspondeStatus;
      });
    }
  },
  watch: {
    'filtroContas.texto'() {
      this.paginaContas = 1;
    },
    'filtroContas.status'() {
      this.paginaContas = 1;
    }
  },
  mounted() {
    this.usuarioLogado = getUsuario();
    
    // Abrir modal de loading
    this.$nextTick(() => {
      // this.abrirLoadingModal();
      this.abrirLoading();
      this.buscarEstatisticas();
      this.carregarSolicitacoes();
      this.carregarEstudantes();
      this.carregarContas();
      this.carregarNovosAssinantes();
    });

    // Adicione este listener
    const modalEl = document.getElementById('loadingModal');
    if (modalEl) {
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.loadingModalAberto = false;
      });
    }

    this.ajustarTamanhoCardPrincipal();
  },
  methods: {

    irParaPaginaContas(pagina) {
      this.paginaContas = Math.min(Math.max(pagina, 1), this.totalPaginasContas);
    },

    irParaPaginaSolicitacoes(pagina) {
      this.paginaSolicitacoes = Math.min(Math.max(pagina, 1), this.totalPaginasSolicitacoes);
    },

    irParaPaginaEstudantes(pagina) {
      this.paginaEstudantes = Math.min(Math.max(pagina, 1), this.totalPaginasEstudantes);
    },

    selecionarAba(aba) {
      this.activeAba = aba;
      if (aba === 'estudantes') this.atualizarLicencas();
      if (aba === 'contas') this.carregarContas();
      if (aba === 'visao-geral') {
        this.buscarEstatisticas();
        this.carregarNovosAssinantes();
      }
    },

    async atualizarLicencas() {
      this.abrirLoading('Atualizando solicitações', 'Aguarde enquanto carregamos as licenças estudantis.');
      try {
        await Promise.all([this.carregarSolicitacoes(), this.carregarEstudantes()]);
      } finally {
        this.fecharLoading();
      }
    },

    formatarMedia(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading(title, message) {
      this.loading.title = title || 'Carregando dados';
      this.loading.message = message || 'Aguarde um momento...';
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    ajustarTamanhoCardPrincipal() {
      const card = document.querySelector(".card-principal");
      if (card) {
        card.style.maxWidth = "1400px";
      }
    },

    formatarData(data) {
      if (!data) return '-';
      return new Date(data).toLocaleString('pt-BR');
    },

    formatarDataUnix(timestamp) {
      if (!timestamp) return '-';
      return new Date(timestamp * 1000).toLocaleDateString('pt-BR');
    },

    formatarDataGrafico(data) {
      return new Date(`${data}-01T00:00:00`).toLocaleDateString('pt-BR', {
        month: 'short',
        year: 'numeric'
      });
    },

    alturaBarra(quantidade) {
      const maiorQuantidade = Math.max(
        1,
        ...this.serieNovosAssinantes.map((item) => item.quantidade)
      );
      return quantidade ? Math.max(8, (quantidade / maiorQuantidade) * 100) : 3;
    },

    formatarTempo(conta) {
      if (conta.dias_restantes === null) return 'Vitalício';
      if (conta.status === 'expirada') return 'Expirada';
      return `${conta.dias_restantes} ${conta.dias_restantes === 1 ? 'dia' : 'dias'}`;
    },

    async carregarSolicitacoes() {
      if (!this.usuarioLogado?.email) return;

      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/solicitacoes-licenca-estudante`, {
          headers: {
            'x-user-email': this.usuarioLogado.email,
            'x-session-id': getSessionId()
          }
        });
        if (!resposta.ok) throw new Error('Não foi possível carregar as solicitações.');
        const dados = await resposta.json();
        this.solicitacoes = dados.solicitacoes || [];
        this.paginaSolicitacoes = 1;
      } catch (error) {
        console.error('Erro ao carregar solicitações estudantis:', error);
        this.abrirAlert('Sistema', error.message, 'error');
      }
    },

    async carregarEstudantes() {
      if (!this.usuarioLogado?.email) return;

      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/usuarios-estudantes`, {
          headers: {
            'x-user-email': this.usuarioLogado.email,
            'x-session-id': getSessionId()
          }
        });
        if (!resposta.ok) throw new Error('Não foi possível carregar os usuários estudantes.');
        const dados = await resposta.json();
        this.estudantes = dados.estudantes || [];
        this.paginaEstudantes = 1;
      } catch (error) {
        console.error('Erro ao carregar usuários estudantes:', error);
        this.abrirAlert('Sistema', error.message, 'error');
      }
    },

    async carregarContas() {
      if (!this.usuarioLogado?.email) return;

      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/usuarios`, {
          headers: {
            'x-user-email': this.usuarioLogado.email,
            'x-session-id': getSessionId()
          }
        });
        if (!resposta.ok) throw new Error('Não foi possível carregar as contas.');
        const dados = await resposta.json();
        this.contas = dados.contas || [];
        this.paginaContas = 1;
      } catch (error) {
        console.error('Erro ao carregar contas:', error);
        this.abrirAlert('Sistema', error.message, 'error');
      }
    },

    async carregarNovosAssinantes() {
      if (!this.usuarioLogado?.email) return;

      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/novos-assinantes?ano=${this.filtroAnoAssinantes}`, {
          headers: {
            'x-user-email': this.usuarioLogado.email,
            'x-session-id': getSessionId()
          }
        });
        if (!resposta.ok) throw new Error('Não foi possível carregar os novos assinantes.');
        const dados = await resposta.json();
        this.stats = {
          ...this.stats,
          novosAssinantes: dados.novosAssinantes || 0,
          serieNovosAssinantes: dados.serieNovosAssinantes || []
        };
      } catch (error) {
        console.error('Erro ao carregar novos assinantes:', error);
        this.abrirAlert('Sistema', error.message, 'error');
      }
    },

    async visualizarCarteirinha(solicitacao) {
      this.abrirLoading('Baixando carteirinha', 'Aguarde enquanto preparamos o arquivo.');
      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/solicitacoes-licenca-estudante/${solicitacao.id}/carteirinha`, {
          headers: {
            'x-user-email': this.usuarioLogado.email,
            'x-session-id': getSessionId()
          }
        });
        if (!resposta.ok) throw new Error('Não foi possível baixar a carteirinha.');
        const arquivo = await resposta.blob();
        const url = URL.createObjectURL(arquivo);
        const link = document.createElement('a');
        link.href = url;
        link.download = solicitacao.carteirinha?.nome || 'carteirinha-estudante';
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (error) {
        this.abrirAlert('Sistema', error.message, 'error');
      } finally {
        this.fecharLoading();
      }
    },

    async aprovarSolicitacao(solicitacao) {
      await this.analisarSolicitacao(solicitacao, 'aprovar');
    },

    async rejeitarSolicitacao(solicitacao) {
      await this.analisarSolicitacao(solicitacao, 'rejeitar');
    },

    async analisarSolicitacao(solicitacao, acao, corpo = {}) {
      this.abrirLoading(
        acao === 'aprovar' ? 'Aprovando solicitação' : 'Rejeitando solicitação',
        'Aguarde enquanto atualizamos o acesso do estudante.'
      );
      try {
        const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/solicitacoes-licenca-estudante/${solicitacao.id}/${acao}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-user-email': this.usuarioLogado.email,
            'x-session-id': getSessionId()
          },
          body: JSON.stringify(corpo)
        });
        const dados = await resposta.json();
        if (!resposta.ok) throw new Error(dados.message || 'Não foi possível analisar a solicitação.');
        this.abrirAlert('Solicitação estudantil', dados.message, 'success');
        await Promise.all([this.carregarSolicitacoes(), this.carregarEstudantes()]);
      } catch (error) {
        this.abrirAlert('Sistema', error.message, 'error');
      } finally {
        this.fecharLoading();
      }
    },
    
    async buscarEstatisticas() {
      try {
        if (!this.usuarioLogado?.email) return;

        const res = await fetch(`${process.env.VUE_APP_BACKEND_URL}/admin/stats`, {
          headers: {
            "x-user-email": this.usuarioLogado.email
          }
        });

        // NÃO ADMIN
        if (res.status === 403) {
          const error = await res.json();

          if (error.code === 'NOT_ADMIN') {
            this.abrirAlert('Acesso Negado', 'Você não tem permissão para acessar esta área.', 'error');

            // opcional: redirecionar
            this.$router.push('/');
            return;
          }
        }

        // NÃO AUTENTICADO
        if (res.status === 401) {
          this.abrirAlert('Sessão inválida', 'Faça login novamente.', 'error');
          this.$router.push('/login');
          return;
        }

        if (!res.ok) {
          throw new Error('Erro ao buscar dashboard');
        }

        const data = await res.json();
        const estatisticas = { ...data };
        delete estatisticas.novosAssinantes;
        this.stats = {
          ...this.stats,
          ...estatisticas
        };

      } catch (err) {
        console.error('Erro dashboard:', err);
        this.abrirAlert('Sistema', 'Erro ao carregar o dashboard.', 'error');
        
      } finally {
        this.carregando = false;

        // Fecha o loading com leve delay (UX)
        setTimeout(() => {
          this.fecharLoading();
        }, 500);
      }
    }

  }
};
</script>

<style scoped>
.dashboard-card {
  background: #ffffff;
  border: 1px solid #EDEFF2;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.2s ease;
}

.dashboard-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.icon-box {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

/* Cores suaves */
.bg-primary-soft { background: #F0F4FF; color: #0056FF; }
.bg-success-soft { background: #ECFDF3; color: #16A34A; }
.bg-warning-soft { background: #FFF7ED; color: #EA580C; }
.bg-info-soft    { background: #EFF6FF; color: #2563EB; }
.bg-danger-soft  { background: #FEE2E2; color: #DC2626; }
.bg-secondary-soft { background: #F3F4F6; color: #6B7280; }

.dashboard-section-title {
  color: #172033;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.3;
}

.dashboard-tabs { border-bottom: 1px solid #EDEFF2; display: flex; gap: 24px; margin: 24px 0 8px; overflow-x: auto; }
.dashboard-tab { background: transparent; border: 0; border-bottom: 2px solid transparent; color: #6B7280; cursor: pointer; font-size: 14px; font-weight: 700; padding: 12px 2px 11px; white-space: nowrap; }
.dashboard-tab:hover { color: #0056FF; }
.dashboard-tab--active { border-bottom-color: #0056FF; color: #0056FF; }

.label {
  font-size: 13px;
  color: #6B7280;
  margin-bottom: 2px;
}

.value {
  font-weight: 700;
  margin: 0;
}

.student-request-empty,
.student-request {
  background: #ffffff;
  border: 1px solid #EDEFF2;
  border-radius: 12px;
  padding: 20px;
}

.account-filters { align-items: flex-start; display: flex; gap: 12px; margin-bottom: 16px; margin-top: 3rem; }
.account-filters input,
.account-filters select { background: #ffffff; border: 1px solid #D4DCE8; border-radius: 6px; color: #172033; padding: 10px 12px; }
.account-filters input { width: 100%; }
.account-filter--search { display: flex; flex: 1; flex-direction: column; gap: 20px; min-width: 220px; }
.account-filter--status { display: flex; flex-direction: column; gap: 20px; min-width: 180px; }
.account-filter-label { color: #172033; font-size: 1rem; font-weight: 700; line-height: 1.3; }
.account-filters select {
  min-width: 160px;
  width: 100%;
  padding-right: 32px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='m2.5 4.5 3.5 3 3.5-3' fill='none' stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/svg%3E");
  background-position: right 12px center;
  background-repeat: no-repeat;
}

.student-request + .student-request { margin-top: 12px; }
.student-request__header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; }
.student-request__header h6 { color: #172033; font-weight: 700; margin: 0 0 4px; }
.student-request__header span:not(.request-status) { color: #6B7280; font-size: 14px; }
.student-request__details { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin: 18px 0 0; }
.student-request__details div { min-width: 0; }
.student-request__details dt { color: #6B7280; font-size: 12px; margin-bottom: 4px; }
.student-request__details dd { color: #172033; font-size: 14px; margin: 0; overflow-wrap: anywhere; }
.student-request__actions { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 18px; }
.botao-vermelho { background-color: #FFF1F1; border: none; border-radius: 8px; color: #DC3545; font-weight: 700; padding: 10px 20px; }
.botao-vermelho:hover { background-color: #DC3545; color: #FFFFFF; }
.request-status { border-radius: 999px; font-size: 12px; font-weight: 700; padding: 5px 10px; text-transform: capitalize; }
.request-status--pendente { background: #FFF7ED; color: #C2410C; }
.request-status--aprovada { background: #ECFDF3; color: #15803D; }
.request-status--rejeitada { background: #FEE2E2; color: #B91C1C; }
.request-status--expirada { background: #FEE2E2; color: #B91C1C; }
.new-subscribers-panel { background: #ffffff; border: 1px solid #EDEFF2; border-radius: 12px; padding: 20px; }
.new-subscribers-panel__header { align-items: center; display: flex; justify-content: space-between; gap: 16px; }
.dashboard-panel-subtitle { color: #6B7280; font-size: 13px; }
.new-subscribers-panel__count { color: #0056FF; font-size: 28px; }
.new-subscribers-panel__year { appearance: none; background-color: #FFFFFF; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='m2.5 4.5 3.5 3 3.5-3' fill='none' stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'/%3E%3C/svg%3E"); background-position: right 10px center; background-repeat: no-repeat; border: 1px solid #D4DCE8; border-radius: 6px; color: #172033; font-size: 13px; font-weight: 700; padding: 8px 30px 8px 10px; }
.new-subscribers-chart { align-items: flex-end; border-top: 1px solid #EDEFF2; display: flex; gap: 8px; min-height: 210px; overflow-x: auto; padding: 20px 4px 0; }
.new-subscriber-chart__item { align-items: center; display: flex; flex: 0 0 72px; flex-direction: column; height: 180px; justify-content: flex-end; min-width: 72px; }
.new-subscriber-chart__quantity { color: #172033; font-size: 11px; font-weight: 700; height: 18px; }
.new-subscriber-chart__track { align-items: flex-end; background: #F1F5F9; border-radius: 4px 4px 0 0; display: flex; height: 130px; overflow: hidden; width: 100%; }
.new-subscriber-chart__bar { background: #0056FF; border-radius: 4px 4px 0 0; min-height: 3px; transition: height 0.25s ease; width: 100%; }
.new-subscriber-chart__item small { color: #6B7280; font-size: 10px; font-weight: 700; margin-top: 8px; white-space: nowrap; }

.student-users-table-wrapper { overflow-x: auto; }
.student-users-table { background: #ffffff; border: 1px solid #EDEFF2; border-collapse: separate; border-radius: 12px; border-spacing: 0; min-width: 760px; overflow: hidden; width: 100%; }
.student-users-table th,
.student-users-table td { border-bottom: 1px solid #EDEFF2; padding: 14px 16px; text-align: left; vertical-align: middle; }
.student-users-table th { background: #F8FAFC; color: #6B7280; font-size: 12px; font-weight: 700; text-transform: uppercase; }
.student-users-table td { color: #172033; font-size: 14px; }
.student-users-table tbody tr:last-child td { border-bottom: 0; }
.student-users-table td strong,
.student-users-table td small { display: block; }
.student-users-table td small { color: #6B7280; margin-top: 3px; }

.pagination-projetos { gap: 6px; margin-top: 24px; }
.pagination-projetos .page-item { margin: 0; }
.pagination-projetos .page-link {
  align-items: center;
  background-color: #FFFFFF;
  border: 1px solid #EDEFF2;
  border-radius: 8px !important;
  color: #3E4449;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  min-width: 40px;
  padding: 8px 12px;
}
.pagination-projetos .page-link:hover {
  background-color: #EDF7FF;
  border-color: #0056FF;
  color: #0056FF;
}
.pagination-projetos .page-item.active .page-link {
  background-color: #0056FF;
  border-color: #0056FF;
  color: #FFFFFF;
}
.pagination-projetos .page-item.disabled .page-link,
.pagination-projetos .page-link:disabled {
  background-color: #F5F6F7;
  border-color: #EDEFF2;
  color: #AAB0B6;
  opacity: 1;
}

@media (max-width: 768px) {
  .account-filters { flex-direction: column; }
  .account-filter--search,
  .account-filter--status { min-width: 0; width: 100%; }
  .account-filter--status { margin-top: 1rem; }
  .account-filters input,
  .account-filters select { width: 100%; }
  .student-request__details { grid-template-columns: repeat(2, 1fr); }
  .new-subscribers-chart { gap: 6px; }
}
</style>
